import { render } from "./AddDynamicPlayerModal.vue?vue&type=template&id=8b965ed6"
import script from "./AddDynamicPlayerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDynamicPlayerModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/AddDynamicPlayerModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b965ed6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b965ed6', __exports__)) {
    api.reload('8b965ed6', __exports__)
  }
  
  module.hot.accept("./AddDynamicPlayerModal.vue?vue&type=template&id=8b965ed6", () => {
    api.rerender('8b965ed6', render)
  })

}


export default __exports__